export default __webpack_public_path__ + "static/media/loader-modeicons.490d993f.svg";